import { Dialog } from '@/components/ui';
import { MetricCard } from '@/components/metrics-guide/MetricCard';
import type { IMetricDefinition } from '@skystone/shared';

interface MetricPreviewModalProps {
  open: boolean;
  onClose: () => void;
  definition: IMetricDefinition;
}

export function MetricPreviewModal({ open, onClose, definition }: Readonly<MetricPreviewModalProps>) {
  return (
    <Dialog open={open} onClose={onClose} title={`Preview: ${definition.name}`}>
      <div className="max-h-[70vh] overflow-auto">
        <MetricCard definition={definition} />
      </div>
    </Dialog>
  );
}
